<template>
  <div style="background: #f7f7f8; padding: 20px 0">
    <div class="content-center">
      <div class="title">隐私条款</div>
      <div class="p">
        货拉拉非常重视对用户（以下简称“您”或“用户”）隐私的保护，为了给您提供更准确、更有个性化的服务，请您仔细阅读如下声明。当您访问货拉拉网站或使用货拉拉提供的服务前，您需要同意隐私政策中具体个人信息的收集、使用、公布和以其它形式使用和披露您的个人信息等内容。但货拉拉会以高度的勤勉、审慎义务对待您的个人信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，货拉拉不会将这些信息对外披露或向第三方提供。如果您不同意隐私政策中的任何内容，请立即停止使用或访问货拉拉。本协议为货拉拉用户许可协议不可分割的组成部分。<br />
        一、货拉拉隐私政策的适用范围 1.1适用范围<br />
        1.1.1在您注册货拉拉时，您根据货拉拉要求提供的个人注册信息，包括但不限于姓名、地址、联系方式等（货拉拉应法律法规要求需公示的企业名称及相关工商注册信息除外）；<br />
        1.1.2在您使用货拉拉网络服务，或访问货拉拉平台网页时，货拉拉自动接收并记录您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；<br />
        1.1.3货拉拉通过合法途径从商业伙伴处取得的用户个人数据。<br />
        1.2您了解并同意，以下信息不适用本隐私权政策：<br />
        1.2.1您在使用货拉拉平台提供的搜索服务时输入的关键字信息；<br />
        1.2.2货拉拉收集到的您在货拉拉发布的有关信息数据，包括但不限于成交信息及评价详情；<br />
        1.2.3违反法律规定或违反货拉拉规则行为及货拉拉已对您采取的措施。<br />
        二、货拉拉收集信息的使用<br />
        2.1货拉拉利用从所有服务中收集的信息来提供、维护、保护和改进这些服务，同时开发新的服务为您带来更好的用户体验，并提高货拉拉的总体服务品质。货拉拉还会向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者经您的事先同意，与货拉拉合作伙伴共享信息以便他们向您发送有关其产品和服务的信息。<br />
        2.2货拉拉不会向任何无关第三方（即不包括货拉拉的关联公司或合作公司）提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该无关第三方和货拉拉（含货拉拉关联公司）单独或共同为您提供服务时，在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。<br />
        2.3货拉拉亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何货拉拉平台用户如从事上述活动，一经发现，货拉拉有权立即终止与该用户的服务协议。<br />
        三、您完全理解并不可撤销地、免费地授予货拉拉及其关联公司下列权利<br />
        3.1货拉拉关联公司或合作公司允许货拉拉用户登录关联公司或合作公司并使用其服务，货拉拉用户在关联公司或合作公司的任何行为均需遵守该等平台服务协议的约定、平台公布的规则以及有关正确使用平台服务的说明和操作指引。为了实现上述功能，您同意货拉拉将您在货拉拉的注册信息、交易/支付数据等信息和数据同步至关联公司或合作公司系统并允许其使用。<br />
        3.2如您以货拉拉关联公司或合作公司用户账号和密码登录货拉拉，为了实现向您提供同等服务的功能，您同意货拉拉将您在关联公司或合作公司账号项下的注册信息、交易/支付数据等信息和数据同步至货拉拉系统并进行使用，并且您不会因此追究货拉拉以及货拉拉关联公司或合作公司的责任。<br />
        3.3为确保交易安全，允许货拉拉及其关联公司对用户信息进行数据分析，并允许货拉拉及其关联公司对上述分析结果进行商业利用。<br />
        3.4您在享受货拉拉提供的各项服务的同时，授权并同意接受货拉拉向您的电子邮件、手机、通信地址等发送商业信息，包括不限于最新的货拉拉产品信息、促销信息等。若您选择不接受货拉拉提供的各类信息服务，您可以按照货拉拉网提供的相应设置拒绝该类信息服务。<br />
        3.5用户在如下情况下，货拉拉会遵照您的意愿或法律的规定披露您的个人信息，由此引发的问题将由您个人承担：<br />
        3.5.1事先获得您的同意向第三方披露；<br />
        3.5.2为提供您所要求的产品和服务，而必须与第三方分享您的个人信息；<br />
        3.5.3根据有关的法律法规的规定，或者依据行政机关或司法机关的要求，向第三方或者行政、司法机构披露；<br />
        3.5.4如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；<br />
        3.5.5如您出现违反中国有关法律、法规或者货拉拉服务协议或相关规则的情况，需要向第三方披露；<br />
        3.5.6在货拉拉上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，货拉拉有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决；<br />
        3.5.7其他货拉拉根据法律、法规或者货拉拉政策认为合适的披露。<br />
        四、信息存储和交换<br />
        4.1货拉拉收集的有关您的信息和资料将保存在货拉拉及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或货拉拉收集信息和资料所在地的境外并在境外被访问、存储和展示。<br />
        五、Cookies的使用<br />
        5.1在您未拒绝接受cookies的情况下，货拉拉会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的货拉拉服务或功能。货拉拉使用cookies可为您提供更加周到的个性化服务，包括推广服务。<br />
        5.2您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的货拉拉服务或功能。<br />
        5.3通过货拉拉所设cookies所取得的有关信息，将适用本政策。<br />
        六、货拉拉对信息的维护与保护<br />
        6.1货拉拉希望用户放心的使用货拉拉的产品和服务，为此货拉拉设置了安全程序保护您的信息不会被未经授权的人访问、窃取。但也请您妥善保管您的账户信息。货拉拉将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在绝对完善的安全措施。<br />
        6.2在使用货拉拉服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，请您立即联络货拉拉客服，以便货拉拉采取相应措施。<br />
        七、合作伙伴<br />
        7.1货拉拉选择有信誉的第三方公司或网站作为货拉拉的合作伙伴为用户提供信息和服务，尽管货拉拉只选择有信誉的公司或网站作为货拉拉的合作伙伴，但是每个合作伙伴都会有与货拉拉不同的隐私条款，一旦您通过点击进入了合作伙伴的网站，货拉拉的隐私条款将不再生效，货拉拉建议您查看该合作伙伴网站的隐私条款，并了解该合作伙伴对于收集、使用、披露您的个人信息的规定。<br />
        八、关于隐私条款的变更<br />
        8.1货拉拉将根据法律、法规或政策的变更和修改，或货拉拉网站内容的变化和技术的更新，或其他货拉拉认为合理的原因，对本隐私政策进行修改并以网站公告、用户通知等合适的形式告知用户，若您不接受修订后的条款的，应立即停止使用本服务，若您继续使用本服务的，视为接受修订后的所有条款。<br />
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.content-center {
  width: 1080px;
  margin: 0 auto;
  background: #fff;
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #2f3439;
    line-height: 18px;
    padding: 20px 42px;
    position: relative;
    border-bottom: 1px solid #f3f3f3;
  }
  .title::before {
    content: "";
    width: 2px;
    height: 13px;
    background: #f16622;
    position: absolute;
    top: 22px;
    left: 22px;
  }
  .p {
    font-size: 12px;
    color: #768191;
    line-height: 18px;
    padding: 15px 22px;
  }
}
</style>